/** SIRET formaté + icône copier (chiffres seuls). */
import { CopyButton } from "../../components/CopyButton";
import { formatSiret } from "./format";

type SiretValueProps = {
  value: string | null | undefined;
  className?: string;
};

export function SiretValue({ value, className = "" }: SiretValueProps) {
  const digits = (value || "").replace(/\D/g, "");
  if (digits === "") return <span className={className}>—</span>;
  return (
    <span className={`fx-siret-val ${className}`.trim()}>
      <span className="siret">{formatSiret(value)}</span>
      <CopyButton text={digits} label="Copier le SIRET" />
    </span>
  );
}
